export default __webpack_public_path__ + "static/media/damaged_mask.af8a3bff.png";